import Image from "next/image";

const Category_Card = ({ imgSrc, title, description }) => {
  return (
    <div className="text-center">
      <div className="rounded-[50%] w-[100px] h-[100px] lg:w-[7.5vw] lg:h-[7.5vw] overflow-hidden flex mb-5 lg:mb-[2vw] p-6 lg:p-[2vw] border-[1px] border-black mx-auto">
        <Image
          src={imgSrc}
          width={50}
          height={50}
          alt={title}
          className="m-auto"
        />
      </div>

      <div className="title font-secondary text-[16px] lg:text-[1.4vw] !mb-4 lg:!mb-[1vw]">
        {title}
      </div>
      <p
        dangerouslySetInnerHTML={{ __html: description }}
        className="text-black"
      ></p>
    </div>
  );
};
export default Category_Card;
